import type { AttachedFile, UploadedFileType } from './files';
import type { MessageCore, WebsocketErrorType, WebSocketMessageCSATButton } from './ws-events';

export enum MessageSendStatus {
  Sent = 'sent',
  NotSent = 'not-sent',
}

export interface MessageJsonButtons {
  title: string;
  titleHtml?: string | null;
  buttons: WebSocketMessageCSATButton[];
  selectedValue?: string;
}

export interface ErrorMessage {
  message: string;
  errorType: WebsocketErrorType;
}

/** Ошибка rate limit от API */
export interface RateLimitError {
  message: string;
  errorType: string;
}

/** Ошибка с флагом rate limit */
export interface RateLimitErrorResponse {
  isRateLimit: true;
  errorData: RateLimitError | null;
}

interface BaseMessage extends MessageCore {
  attachments?: AttachedFile[] | UploadedFileType[];
  messageJson: string | null | MessageJsonButtons;
  entryPointGateway?: string;
  maxUserPhone?: string;
}

/** Чатовое сообщение */
interface ChatMessage extends BaseMessage {
  status?: MessageSendStatus;
}

/** Любое сообщение с кнопками внутри */
export interface MessageWithButtons extends BaseMessage {
  buttonsDisabled?: boolean;
}

export type CsatRatingMessage = BaseMessage;

/** Сообщение в виджете, запрос CSAT или сообщение с кнопками */
export type Message = ChatMessage | CsatRatingMessage | MessageWithButtons;
export interface SubmitMessageProps {
  message: string;
  attachments?: UploadedFileType[];
  phoneNumber?: string;
}
